import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import {
  initializePdf,
  initializeViewer,
  getToc,
  SCROLL_DIRECTION_VERTICAL,
} from "biblioboard-pdf-viewer";
import "biblioboard-pdf-viewer/src/style.css";
import yellow from "@material-ui/core/colors/yellow";

const styles = {
  "@global": {
    ".bb-pdf-spread-container": {
      margin: 10,
      boxShadow: "0 2px 2px 0 rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.12)",
    },
    ".bb-pdf-page-text-layer .highlight": {
      backgroundColor: "rgba(255,255,0,0.3)",
      borderColor: yellow[200],
    },
  },
  pdfViewer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden",
  },
};

class PdfViewer extends Component {
  static defaultProps = {
    scrollDirection: SCROLL_DIRECTION_VERTICAL,
    pagesPerSpread: 1,
    spreadMargin: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    gestures: true,
    pageNumber: 1,
    zoom: 1,
    searchQuery: "",
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.viewer) {
      if (this.props.pageNumber !== prevProps.pageNumber) {
        this.viewer.setPageNumber(this.props.pageNumber);
      }

      if (this.props.zoom !== prevProps.zoom) {
        this.viewer.setZoom(this.props.zoom);
      }

      if (this.props.searchQuery !== prevProps.searchQuery) {
        if (this.props.searchQuery) {
          this.viewer.search(this.pdf, this.props.searchQuery);
        } else {
          this.viewer.clearSearchResults();
        }
      }
    }
  }

  async componentDidMount() {
    const [pdf, pdfPages] = await initializePdf(this.props.url);

    this.pdf = pdf;

    if (this.props.onPdfLoaded) {
      this.props.onPdfLoaded({
        pageCount: pdfPages.length,
      });
    }

    if (this.props.onTocLoaded) {
      getToc(this.pdf).then(toc => this.props.onTocLoaded(toc));
    }

    this.viewer = initializeViewer(
      this.viewerElement,
      pdf,
      pdfPages,
      this.props.scrollDirection,
      this.props.pagesPerSpread,
      this.props.spreadMargin,
      this.props.gestures,
      this.props.pageNumber,
    );

    this.viewer.addEventListener("pageChange", event => {
      if (this.props.onPageChange) {
        this.props.onPageChange(event);
      }
    });

    this.viewer.addEventListener("zoomChange", event => {
      if (this.props.onZoomChange) {
        this.props.onZoomChange(event);
      }
    });

    this.viewer.addEventListener("searchMatches", event => {
      if (this.props.onSearchMatches) {
        this.props.onSearchMatches(event);
      }
    });

    this.wheelListener = e => e.preventDefault();
    this.resizeListener = () => {
      this.viewer.resetLayout();

      if (this.props.onZoomChange) {
        this.props.onZoomChange({
          viewer: this.viewer,
          zoom: 1,
        });
      }
    };

    this.viewerElement.addEventListener("wheel", this.wheelListener, {
      passive: false,
    });

    window.addEventListener("resize", this.resizeListener);
  }

  componentWillUnmount() {
    this.viewerElement.removeEventListener("wheel", this.wheelListener);
    window.removeEventListener("resize", this.resizeListener);
  }

  render() {
    const { classes } = this.props;

    return (
      <div
        className={classes.pdfViewer}
        ref={viewerElement => (this.viewerElement = viewerElement)}
      />
    );
  }
}

export default withStyles(styles)(PdfViewer);
